import axios from "axios";
import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import UserDataContext from "../../context/UserDataContext";

function NewOrder() {
  const [recordData, setRecordData] = useState({});
  const [error, setError] = useState(false);
  const token = localStorage.getItem("token");
  const history = useHistory();
  const { userData } = useContext(UserDataContext);
  const project = localStorage.getItem("currentProjectID");
  const { id } = useParams();

  async function register(e) {
    e.preventDefault();
    try {
      recordData["service"] = id;
      recordData["project"] = project;
      recordData["createdBy"] = userData.name;
      await axios.post(
        `${process.env.REACT_APP_BACKEND}/services/order/new`,
        recordData,
        {
          headers: {
            jwttoken: token,
          },
        }
      );
      history.push("/services/edit/" + id);
    } catch (err) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 5000);
    }
  }

  useEffect(() => {}, [userData]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-center">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Neue Bestellung hinzufügen
          </h3>
        </div>
      </div>
      <div className="bg-white overflow-hidden sm:rounded-lg flex justify-center my-5">
        <div className="container flex justify-start w-full">
          <div className="flex flex-col grow">
            <div className="border-b border-gray-200 shadow overflow-hidden sm:rounded-lg">
              <form onSubmit={register}>
                <div className="shadow overflow-hidden sm:rounded-md">
                  <div className="px-4 py-5 bg-white sm:p-6">
                    <div className="grid grid-cols-6 gap-6">
                      <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Bestelldatum
                        </label>
                        <input
                          type="date"
                          required="true"
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              orderDate: e.target.value,
                            })
                          }
                          value={recordData.orderDate}
                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="col-span-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Kommentar
                        </label>
                        <input
                          type="text"
                          onChange={(e) =>
                            setRecordData({
                              ...recordData,
                              comment: e.target.value,
                            })
                          }
                          value={recordData.comment}
                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-lg border-gray-300 rounded-md"
                        />
                      </div>
                      <div className="col-span-2">
                        <label class="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            class="sr-only peer"
                            onChange={(e) =>
                              setRecordData({
                                ...recordData,
                                nachtschicht: e.target.checked,
                              })
                            }
                          />
                          <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                          <span class="ms-3 text-sm font-medium text-gray-700">
                            Nachtschicht?
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Speichern
                    </button>
                    {error && (
                      <div
                        className="flex rounded-md items-center bg-red-500 text-white text-sm font-bold px-4 py-3 my-5"
                        role="alert"
                      >
                        <svg
                          className="fill-current w-6 h-6 mr-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
                        </svg>
                        <p>
                          Fehler beim speichern. Bitte wenden Sie sich an einen
                          Administrator.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewOrder;
